import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { TGetUserListResDto } from "@/api/services/main/user/dtos/get-user-list.dto";
import { CACHED_TIME } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { TOption } from "@/types/common";
import { clientApi } from "@/utils/api";

/**
 * 担当者候補 (person-in-charge) — org users for assignee pickers:
 *   GET /users/person-in-charge -> org USER accounts
 */
export const fetchPersonInChargeUsersApi = async (): Promise<TGetUserListResDto> => {
  const { data } = await clientApi.get<TGetUserListResDto>("/users/person-in-charge");
  return data;
};

export const usePersonInChargeUsers = () => {
  const query = useQuery({
    queryKey: [QUERY_KEYS.USER.FETCH_PERSON_IN_CHARGE],
    queryFn: fetchPersonInChargeUsersApi,
    staleTime: CACHED_TIME,
    gcTime: CACHED_TIME,
  });

  return { ...query, users: query.data?.data ?? [] };
};

/** セレクト用の {label, value} に変換した 担当者候補（主担当者ピッカー用）。 */
export const usePersonInChargeOptions = () => {
  const { users, isLoading } = usePersonInChargeUsers();

  const options = useMemo<TOption[]>(() => users.map(({ id, fullName }) => ({ label: fullName, value: String(id) })), [users]);

  return { options, isLoading };
};
